import { render, staticRenderFns } from "./PartnerFaqEditDialog.vue?vue&type=template&id=57fa4e04&scoped=true&"
import script from "./PartnerFaqEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PartnerFaqEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFaqEditDialog.vue?vue&type=style&index=0&id=57fa4e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa4e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
